const hamburger = document.querySelector(
	'.block-primary-navigation__hamburger'
);
const mobileBackButton = document.querySelector(
	'.block-primary-navigation__mobile-menu-header-back'
);
const mobileMenuHeaderTitle = document.querySelector(
	'.block-primary-navigation__mobile-menu-header-title'
);
const languageButton = document.querySelector(
	'.block-primary-navigation__header-buttons-language'
);
const languageDropdown = languageButton.parentNode.querySelector(
	'.block-primary-navigation__header-button-dropdown'
);
const menuLinkButtons = document.querySelectorAll(
	'.block-primary-navigation__header-link-button'
);
const dropdowns = document.querySelectorAll(
	'.block-primary-navigation__dropdown'
);
const dropdownTabs = document.querySelectorAll(
	'.block-primary-navigation__dropdown-tabs-button'
);
let isMobile = window.innerWidth < 1024;
let activeTabRef = null;

/**
 * Initialize Primary Navigation
 */
const primaryNavigationInit = () => {
	/**
	 * Toggle Mobile Menu
	 */
	hamburger?.addEventListener('click', () => {
		const isActive = document.body.classList.toggle('mobile-menu-open');

		hamburger.classList.toggle('active', isActive);

		if (!isActive) {
			closeMenu();
		}
	});

	/**
	 * Close mobile submenu
	 */
	mobileBackButton?.addEventListener('click', () => {
		if (activeTabRef) {
			closeActiveTab();
		} else {
			closeMobileDropdown();
		}
	});

	menuLinkButtons?.forEach((button) => {
		const parent = button.closest('.block-primary-navigation__header-link');
		const isDropdown = parent.querySelector(
			'.block-primary-navigation__dropdown'
		);

		if (!isDropdown) {
			return;
		}

		button.addEventListener('click', (e) => {
			e.preventDefault();

			if (mobileMenuHeaderTitle) {
				mobileMenuHeaderTitle.innerText = e.target.innerText.replace(
					/[\r\n]+/g,
					' '
				);
			}

			const shouldOpen = !parent.classList.contains('active');

			// Deactivate any other open header link before switching
			document
				.querySelectorAll(
					'.block-primary-navigation__header-link.active'
				)
				.forEach((link) => link.classList.remove('active'));

			// Close dropdown if already active
			if (!shouldOpen) {
				closeMobileDropdown();
				return;
			}

			parent.classList.add('active');

			// Close language dropdown
			toggleLanguageDropdown(false);

			dropdowns.forEach((dropdown) => {
				dropdown.setAttribute('aria-hidden', 'true');
			});
			const dropdown = parent.querySelector(
				'.block-primary-navigation__dropdown'
			);
			dropdown?.setAttribute('aria-hidden', 'false');
			if (dropdown) {
				dropdown.scrollTop = 0;
			}

			document.body.classList.add('navigation-dropdown-open');

			// Hide all tab content divs on mobile when opening a tabs dropdown
			if (
				dropdown.classList.contains(
					'block-primary-navigation__dropdown-tabs'
				) &&
				isMobile
			) {
				const tabsContent = dropdown.querySelectorAll(
					'.block-primary-navigation__dropdown-tabs-tab'
				);
				tabsContent.forEach((tab) => {
					tab.setAttribute('aria-hidden', 'true');
				});
			}
		});
	});

	/**
	 * Toggle Dropdown Tab
	 */
	dropdownTabs?.forEach((tabButton) => {
		tabButton.addEventListener('click', () => {
			const tabIndex = tabButton.getAttribute('data-tab-index');
			const dropdown = tabButton.closest(
				'.block-primary-navigation__dropdown-tabs'
			);
			const allTabButtons = dropdown.querySelectorAll(
				'.block-primary-navigation__dropdown-tabs-button'
			);
			const allTabs = dropdown.querySelectorAll(
				'.block-primary-navigation__dropdown-tabs-tab'
			);

			// Deactivate all buttons and tabs
			allTabButtons.forEach((btn) => {
				btn.setAttribute('aria-expanded', 'false');
			});
			allTabs.forEach((tab) => {
				tab.setAttribute('aria-hidden', 'true');
			});

			// Activate the clicked button and corresponding tab
			tabButton.setAttribute('aria-expanded', 'true');
			const activeTab = dropdown.querySelector(
				`.block-primary-navigation__dropdown-tabs-tab[data-tab-index="${tabIndex}"]`
			);
			if (activeTab) {
				activeTab.setAttribute('aria-hidden', 'false');
				activeTabRef = activeTab;
			}
			dropdown.scrollTop = 0;
			if (isMobile) {
				dropdown.classList.add('mobile-tab-open');
			}
		});
	});

	/**
	 * Close dropdown when clicking outside
	 */
	document.addEventListener('mousedown', (e) => {
		// Close language dropdown when clicking outside of it, even on mobile
		if (
			languageDropdown.getAttribute('aria-expanded') === 'true' &&
			!languageDropdown.parentNode.contains(e.target)
		) {
			toggleLanguageDropdown(false);
		}

		// Only close if a dropdown is open
		if (
			(!document.body.classList.contains('navigation-dropdown-open') &&
				!document.body.classList.contains('language-dropdown-open')) ||
			isMobile
		) {
			return;
		}

		// Check if click is inside any open dropdown or menu link
		let clickedInsideDropdown = false;

		dropdowns.forEach((dropdown) => {
			if (
				dropdown.getAttribute('aria-hidden') === 'false' &&
				dropdown.contains(e.target)
			) {
				clickedInsideDropdown = true;
			}
		});

		menuLinkButtons.forEach((button) => {
			if (button.contains(e.target)) {
				clickedInsideDropdown = true;
			}
		});

		if (!clickedInsideDropdown) {
			closeMobileDropdown();
		}
	});

	/**
	 * Listen for custom close mobile menu event
	 */
	document.addEventListener('closeMobileMenu', () => {
		closeMenu();
	});

	/**
	 * Language Button Click
	 */
	languageButton?.addEventListener('click', () => {
		toggleLanguageDropdown();
	});
};

/**
 * Update Primary Navigation on Resize
 */
const updatePrimaryNavigation = () => {
	isMobile = window.innerWidth < 1024;
	closeMenu();
};

/**
 * Move utility bar in DOM
 */
const moveUtilityBar = () => {
	const utilityBar = document.querySelector(
		'.block-primary-navigation__utility-bar'
	);
	const mobileMenu = document.querySelector(
		'.block-primary-navigation__mobile-menu'
	);
	const primaryNavigation = document.querySelector(
		'.block-primary-navigation'
	);

	if (!mobileMenu || !utilityBar || !primaryNavigation) return;

	if (
		isMobile &&
		utilityBar.parentElement.classList.contains('block-primary-navigation')
	) {
		mobileMenu.appendChild(utilityBar);
	} else if (
		!isMobile &&
		utilityBar.parentElement.classList.contains(
			'block-primary-navigation__mobile-menu'
		)
	) {
		primaryNavigation.prepend(utilityBar);
	}
};

/**
 * Close Mobile Dropdown
 */
const closeMobileDropdown = () => {
	document.body.classList.remove('navigation-dropdown-open');
	// Close all dropdowns
	dropdowns?.forEach((dropdown) => {
		dropdown.setAttribute('aria-hidden', 'true');
		dropdown
			.closest('.block-primary-navigation__header-link')
			?.classList.remove('active');
	});
	if (activeTabRef) {
		closeActiveTab();
	}
};

/**
 * Close Menu
 */
const closeMenu = () => {
	closeMobileDropdown(false);
	hamburger.classList.remove('active');
	document.body.classList.remove(
		'navigation-dropdown-open',
		'mobile-menu-open'
	);
};

/**
 * Close Active Tab
 */
const closeActiveTab = () => {
	if (!activeTabRef || !isMobile) return;

	const dropdown = activeTabRef.closest(
		'.block-primary-navigation__dropdown-tabs'
	);

	dropdown.classList.remove('mobile-tab-open');
	activeTabRef.setAttribute('aria-hidden', 'true');
	activeTabRef.classList.remove('mobile-tab-open');
	activeTabRef = null;
};

/**
 * Toggle Language Dropdown
 *
 * @param {boolean} display - Indicates whether to show or hide the language dropdown
 */
const toggleLanguageDropdown = (display) => {
	const dropdownIsActive = document.body.classList.toggle(
		'language-dropdown-open',
		display
	);

	languageDropdown?.setAttribute(
		'aria-expanded',
		dropdownIsActive ? 'true' : 'false'
	);
};

// GLOBAL APP CONTROLLER
const controller = {
	init() {
		primaryNavigationInit();
		moveUtilityBar();
	},
	loaded() {},
	resized() {
		updatePrimaryNavigation();
		moveUtilityBar();
	},
	scrolled() {},
	keyDown() {},
	mouseUp() {},
};
export default controller;
